<template>
  <div>
    <div class="pl-2 pr-2 position-relative" v-if="showSearch">
      <b-form-input
        v-model="search"
        size="sm"
        class="search-input"
        ref="search-input"
        :placeholder="placeholder ? placeholder : 'Search'"
        @mouseleave="checkSelection"
        @keyup="checkSelection"
        @keydown.enter.prevent="checkSelection"
      ></b-form-input>
      <img
        v-if="searching"
        class="img-loading"
        height="20"
        width="20"
        :src="require(`../../assets/icons/loading.gif`)"
      />
    </div>

    <div class="items-container mt-2" :id="id + '-container'">
      <div
        v-for="(option, optionIndex) in filterOptions"
        :key="option.value"
        class="item-container"
        @click="optionClick(option)"
        :class="checkValueSelected(option) ? 'selected-value' : ''"
        :id="id + '_' + optionIndex"
      >
        <span v-show="false" :id="id + '_acronym_' + optionIndex">{{
          option.acronym
        }}</span>
        <slot
          name="item-option"
          v-bind:itemOption="option"
          v-bind:selected="checkValueSelected(option)"
        >
          <div
            class="d-flex flex-row justify-content-between align-items-center mb-1 pl-3 pr-3 pt-1 pb-1"
          >
            <span :id="id + '_label_' + optionIndex"
              >{{ optionIndex + 1 }}. {{ option.label }}</span
            >
            <img :src="require('../../assets/icons/check.png')" />
          </div>
        </slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "MultipleSelectFilter",
  props: [
    "options",
    "label",
    "value",
    "width",
    "showSearch",
    "async",
    "searching",
    "placeholder",
    "id"
  ],
  data() {
    return {
      searchQuery: ""
    };
  },
  methods: {
    checkSelection() {
      const sel = window.getSelection();
      this.$emit("on-text-selection", sel.toString());
    },
    optionClick(option) {
      const newValue = [...this.value];
      if (!this.checkValueSelected(option)) {
        newValue.push(option);
      } else {
        newValue.splice(newValue.map(nV => nV.value).indexOf(option.value), 1);
      }
      this.$emit("input", newValue);
    },
    checkValueSelected(option) {
      return this.value.map(v => v.value).indexOf(option.value) >= 0;
    },
    highlightText() {
      const searchInput = this.$el.getElementsByClassName("search-input")[0];
      searchInput.select();
    }
  },
  computed: {
    filterOptions() {
      if (!this.async && this.showSearch) {
        return this.options.filter(
          option =>
            this.searchQuery == "" ||
            option.label
              .toLowerCase()
              .indexOf(this.searchQuery.toLowerCase()) >= 0
        );
      }
      return this.options;
    },
    search: {
      get() {
        return this.searchQuery;
      },
      set(newValue) {
        if (this.searchQuery) this.$emit("on-search", newValue);
        this.searchQuery = newValue;
      }
    }
  },
  watch: {
    searchQuery() {
      this.$emit("on-search", this.searchQuery);
    }
  }
};
</script>

<style scoped>
.container-main {
  height: 45px;
  width: var(--width);
}
.container-main:hover {
  cursor: pointer;
}
.selected-value {
  color: #2ac51f;
}
.item-container:hover {
  cursor: pointer;
  background-color: lightgray;
}
.item-container img {
  display: none;
}
.selected-value img {
  display: initial;
}
.search-input {
  border-radius: 20px;
}
.img-loading {
  position: absolute;
  top: 5px;
  right: 15px;
}
.items-container {
  max-height: 300px;
  overflow-y: auto;
}
</style>
<style></style>
